import { render, staticRenderFns } from "./TaskProgressionTab.vue?vue&type=template&id=3eb7ba54&"
import script from "./TaskProgressionTab.vue?vue&type=script&lang=js&"
export * from "./TaskProgressionTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports